import { render } from "./SummaryFooterComponent.vue?vue&type=template&id=92e2c0dc&scoped=true"
import script from "./SummaryFooterComponent.vue?vue&type=script&lang=js"
export * from "./SummaryFooterComponent.vue?vue&type=script&lang=js"

import "./SummaryFooterComponent.vue?vue&type=style&index=0&id=92e2c0dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92e2c0dc"]])

export default __exports__